import type { Policy } from '@/features/policies/types';

export const getPolicyRef = (policy: Policy) =>
  policy.external_refs?.find((ref) => ref.company.toLowerCase() === 'anva')
    ?.ref ??
  policy.anva_product_ref ??
  policy.id;
